import {MolecularGraph} from "../../graph/MolecularGraph"
import {extractorUtil} from "../../util/extractorUtil";
import {Feature, Features} from "../../feature";

export const amineExtractor = {
    extract: (graph: MolecularGraph) => {
        const Ns = extractorUtil.getFunctionalGroupRootsWithElement("N", graph);
        const features: Feature[] = [];

        while (Ns.length > 0) {
            const n = Ns.pop()!;
            const bonds = graph.getBondsAttachedTo(n);
            // Total bonds (explicit + implicit H) should be 3
            const totalBonds = bonds.length + n.implicitH;
            if (totalBonds !== 3) {
                continue;
            }

            const Cs = extractorUtil.getSingleBondsToC(n, graph).map(b => b.getOtherAtom(n));
            const explicitHs = extractorUtil.getSingleBondsToH(n, graph).map(b => b.getOtherAtom(n));
            const totalH = extractorUtil.getTotalHydrogenCount(n, graph);
            let name = "";

            if (Cs.length === 1 && totalH === 2) {
                name = Features.amine1 // primary
            } else if (Cs.length === 2 && totalH === 1) {
                name = Features.amine2 // secondary
            } else if (Cs.length === 3) {
                name = Features.amine3 // tertiary
            }

            if (name) {
                features.push({name: name, atoms: [n, ...explicitHs], connections: [...Cs]})
            }
        }

        return features;
    }
}
